import { useEffect, useState } from "react";
import { getVisitor } from "api/ApiPenghapusan";
import Table from "react-bootstrap/Table";
import ilustrasi from "assets/Ilustrasi.svg";
import logoPengunjung from "assets/logo-pengunjung.svg";
import IdentityForm from "component/IdentityForm";
import logo1 from "assets/logo1.png";
import logo2 from "assets/logo2.png";
import logo3 from "assets/logo3.png";
import "pages/Landing.css";

function Landing() {
  const [countVisitor, setCountVisitor] = useState();

  useEffect(() => {
    getVisitor().then((response) => {
      if (response?.data?.data) {
        console.log(response.data.data.visitor);
        setCountVisitor(response.data.data.visitor);
      }
    });
  }, []);

  return (
    <>
      <div className="row wrapper">
        <div className="col-12 green-bgcolor header">
          <div className="p-3 ">
            <div className="white">
              <h2 className="greeting">Sampurasun, Wargi Jabar 👋</h2>
              <p className="m-0">
                Selamat datang di Sistem Informasi Penghapusan Kendaraan
                Bermotor
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 content">
          <IdentityForm />
          <div className="stat-pengunjung-desktop">
            <div className="row mt-4 d-flex justify-content-center">
              <div className="col-6 text-pengunjung">
                <img
                  className="pengunjung-img"
                  src={logoPengunjung}
                  alt="Jumlah pengunjung"
                />
              </div>
              <div className="col-6 pt-3">
                <Table className="table-stat">
                  <tr>
                    <td>Hari ini</td>
                    <td>:</td>
                    <td>&nbsp;{countVisitor?.today}</td>
                  </tr>
                  <tr>
                    <td>Kemarin</td>
                    <td>:</td>
                    <td>&nbsp;{countVisitor?.yesterday}</td>
                  </tr>
                  <tr>
                    <td>Total Pengunjung &nbsp;&nbsp;</td>
                    <td>:</td>
                    <td>&nbsp;{countVisitor?.all}</td>
                  </tr>
                </Table>
              </div>
            </div>
          </div>
        </div>
        <div className="col-12 green-bgcolor">
          <div className="p-3">
          <div className="sponsor-desktop">
              <div className="d-flex justify-content-center">
                <img className="p-2" src={logo2} alt="" />
                <img className="p-2" src={logo1} alt="" />
                <img className="p-2" src={logo3} alt="" />
              </div>
            </div>
            <div className="white">
              <h2 className="desktop-greeting">Sampurasun, Wargi Jabar 👋</h2>
              <p>
                Berdasarkan Undang-Undang Nomor 22 Tahun 2009 Pasal 74 Ayat 2,
                data Kendaraan Bermotor akan dihapuskan jika tidak diregistrasi
                ulang sekurang-kurangnya 2 (dua) tahun setelah habis masa
                berlaku STNK.
              </p>
            </div>
            <div>
              <img
                className="ilustration-img mt-4"
                src={ilustrasi}
                alt="Langkah-langkah Penggunaan Sistem"
              />
            </div>
            <div className="white text-center mt-4">
              <h2 className="secondary-title">
                Segera periksa status kendaraan Anda.
              </h2>
            </div>
          </div>

          <div className="p-3 sponsor">
            <p className="white text-center m-0">Dipersembahkan oleh: </p>
            <div className="d-flex justify-content-center">
              <img className="p-2" src={logo2} alt="" />
              <img className="p-2" src={logo1} alt="" />
              <img className="p-2" src={logo3} alt="" />
            </div>
          </div>
        </div>
        <div className="col-12 content stat-pengunjung-mobile">
          <div className="row mt-4 d-flex justify-content-center">
            <div className="col-6 text-pengunjung">
              <img
                className="pengunjung-img"
                src={logoPengunjung}
                alt="Jumlah pengunjung"
              />
            </div>
            <div className="col-6 pt-3">
              <Table className="table-stat">
                <tr>
                  <td>Hari ini</td>
                  <td>:</td>
                  <td>&nbsp;{countVisitor?.today}</td>
                </tr>
                <tr>
                  <td>Kemarin</td>
                  <td>:</td>
                  <td>&nbsp;{countVisitor?.yesterday}</td>
                </tr>
                <tr>
                  <td>Total Pengunjung &nbsp;&nbsp;</td>
                  <td>:</td>
                  <td>&nbsp;{countVisitor?.all}</td>
                </tr>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Landing;
